import "./style.css";
import { Outlet, Link } from "react-router-dom";

function Rules() {
  return (
    <div className="container">
      <h1>ТУРНИКЕТ</h1>
      <p style={{width: "520px", textAlign: "start"}}>
        <b>ЦЕЛЬ ИГРЫ:</b>
        <br /> Привести все цветные фишки в углы соответствующего цвета!
        <br /> <br />
        <b>ПОДГОТОВКА:</b>
        <br /> Выберите карточку с заданием. Разместите фишки и турникеты
        <br /> на игровом поле в соответствии с рисунком на карточке.
        <br /> <br />
        <b>КАК ИГРАТЬ:</b>
        <br /> 1. Передвигайте серые и цветные фишки (вверх, вниз, влево,
        <br /> вправо), по одной за ход, на соседние клетки игрового поля.
        <br /> 2. Фишка может пройти через встретившийся на ее пути
        <br /> турникет, провернув его на 90 градусов, при условии, что
        <br /> другая фишка или турникет не препятствуют повороту.
        <br /> 3. Когда все цветные фишки находятся в углах
        <br /> соответствующего цвета - Вы победили!
        <br /> <br />
        <b>ПРОСТЫЕ ПРАВИЛА:</b>
        <br /> 1. Одновременно может передвигаться только одна фишка.
        <br /> 2. Фишки могут передвигаться по полю вверх, вниз, влево и
        <br /> вправо, если путь не заблокирован.
        <br /> 3. Фишки проворачивают турникеты проходя через них -
        <br /> турникеты нельзя поворачивать без помощи проходящих через
        <br /> них фишек.
        <br /> 4. Фишки не могут перепрыгивать через турникеты или через
        <br /> другие фишки.
        <br /> 5. Фишка не может провернуть турникет, если другая фишка
        <br /> этому препятствует.
        <br /> 6. Турникет не должен соприкасаться с другими турникетами
        <br /> или двигать их. При правильном повороте турникет должен
        <br /> встать параллельно одной из сторон игрового поля.
        <br /> 7. При решении задания фишки нельзя убирать с поля.
        <br /> <br />
        <b>НЕ ПОЛУЧАЕТСЯ ПРОЙТИ?</b>
        <br /> Верните фишки и турникеты в исходную позицию и попробуйте
        <br /> заново! Пошаговое решение каждого задания показано на
        <br /> обратной стороне карточки с заданием.
      </p>
      <button type="button"><Link to="/"style={{color: "black"}}>Назад</Link></button>
      <Outlet />
    </div>
  );
}

export default Rules;
